export default "__VITE_ASSET__5c9bb56c__"